import React from 'react';
import '../../styles/partial/VinylSleeve.css';

/** The initials on a sleeve with no cover art: the first letters of the first
 * two words of `source`, or of `fallback` when there is no source. */
export const coverLabel = (source, fallback) => (source || fallback || '')
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map((word) => word[0]?.toUpperCase() || '')
  .join('');

/**
 * A song's cover art as a record sleeve, with a vinyl record behind it that
 * slides out and spins (ENG-768). The record moves when an ancestor with
 * `vinyl-sleeve-trigger` is hovered (or, with `vinyl-sleeve-trigger--focus`,
 * focused), or always when `active`. It never spins with reduced motion.
 */
const VinylSleeve = ({
  artworkUrl,
  fallbackLabel,
  alt = '',
  active = false,
  lazy = false,
  className = '',
  coverClassName = '',
  children,
  testId,
}) => (
  <div
    className={`vinyl-sleeve${active ? ' vinyl-sleeve--active' : ''}${className ? ` ${className}` : ''}`}
    data-testid={testId}
  >
    <div className="vinyl-sleeve-record" aria-hidden="true" data-testid={testId ? `${testId}-record` : undefined}>
      {artworkUrl ? (
        <img src={artworkUrl} alt="" className="vinyl-sleeve-record-image" />
      ) : (
        <span className="vinyl-sleeve-record-fallback">{fallbackLabel}</span>
      )}
    </div>
    <div
      className={`vinyl-sleeve-cover${coverClassName ? ` ${coverClassName}` : ''}`}
      data-testid={testId ? `${testId}-cover` : undefined}
    >
      {artworkUrl ? (
        <img src={artworkUrl} alt={alt} className="vinyl-sleeve-cover-image" loading={lazy ? 'lazy' : undefined} />
      ) : (
        <span className="vinyl-sleeve-cover-fallback">{fallbackLabel}</span>
      )}
      {children}
    </div>
  </div>
);

export default VinylSleeve;
